export * from './medical-group.type';
